import { render, staticRenderFns } from "./TableAppointmentFlagHandler.vue?vue&type=template&id=93234032&scoped=true"
import script from "./TableAppointmentFlagHandler.vue?vue&type=script&lang=js"
export * from "./TableAppointmentFlagHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93234032",
  null
  
)

export default component.exports